module.exports = {
    getUrl: Odigeo._.constant('disableautorenewal'),

    getMethod: Odigeo._.constant('PUT'),

    requestSuccess: function() {
        Odigeo.trigger(this.widget.id + ':disableAutoRenewalOk');
    },

    requestError: Odigeo._.noop(),
};
